import React, { useState } from 'react';
import Image from 'next/image';
import styles from './style.module.css';

interface SecureImageProps {
  imageUrl: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const SecureImage: React.FC<SecureImageProps> = ({ 
  imageUrl, 
  alt = 'Secure image',
  width = "100vw",
  height = "100vh",
  className = ''
}) => {
  const [blobUrl, setBlobUrl] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  React.useEffect(() => {
    const fetchImage = async () => {
      try {
        setLoading(true);
        setError(false);
        
        const url = new URL(imageUrl);
        const token = url.searchParams.get('token');

        console.log(url)
        console.log(token)
        
        if (!token) {
          throw new Error('No token found in URL');
        }

        const response = await fetch(imageUrl, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        console.log(response)
        if (!response.ok) {
          throw new Error('Failed to load image');
        }

        const blob = await response.blob();
        console.log(blob)
        const img: HTMLImageElement = new window.Image();
        const objectUrl = URL.createObjectURL(blob);
        console.log(objectUrl)
        img.src = objectUrl;

        img.onload = () => {
            setDimensions({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
            setBlobUrl(objectUrl);            
        };

      } catch (err) {
        console.error('Error loading image:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (imageUrl) {
      fetchImage();
    }

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [imageUrl]);

  if (loading) {
    return (
      <div 
        className={styles.loadingContainer} 
        style={{ width, height }}
      />
    );
  }

  if (error) {
    return (
      <div className={styles.error}>
        Failed to load image
      </div>
    );
  }

  return dimensions.width > 0 ? (
    <div className={styles.container}>
      <Image
        src={blobUrl}
        alt={alt}
        layout="responsive"
        width={dimensions.width}
        height={dimensions.height}
        className={`${styles.image} ${className}`}
        priority
        onError={() => setError(true)}
      />
    </div>
  ) : null;
};